/**
 * Video Fallback Module
 */
( function ( window, document ) {

    var VideoFallback = {

        /**
         * Initialize the Video Fallback module
         */
        init: function () {
            window.addEventListener( 'load', this.maybeReplaceYoutubeIframes.bind( this ) );
        },

        /**
         * Return a promise if a resource can be accessed as an image.
         *
         * @param {string} URL The URL of the image resource.
         * @returns {Promise}
         */
        testImage: function ( URL ) {
            return new Promise( function ( resolve, reject ) {
                var tester = new Image();
                tester.onload = function () { resolve(); };
                tester.onerror = function () { reject(); };
                tester.src = URL;
            });
        },

        /**
         * Checks if YouTube is accessible and if not, replaces the iframe with either a fallback URL or an MP4 video.
         *
         * @returns {void}
         */
        maybeReplaceYoutubeIframes: async function () {
            var allFrames = document.querySelectorAll( "iframe[data-fallback-url]" );

            // If no iframes on the page, bail.
            if ( !allFrames.length || !window.Intl ) {
                return;
            }

			try {
				// Test if YouTube's favicon is accessible.
				await this.testImage('https://www.youtube.com/favicon.ico');
			} catch (error) {
				const fallbackVideo = document.getElementById('fallback-video');

				allFrames.forEach((iframe) => {
					const fallbackUrl = iframe.getAttribute('data-fallback-url');

					if (fallbackUrl) {
						iframe.src = fallbackUrl;
						return;
					}

					if (fallbackVideo) {
						iframe.style.display = 'none';
						fallbackVideo.style.display = 'block';
					}
				});
			}

			// Fallback for when the onerror does not fire (e.g., content-blocked but the iframe still loads)
			const FALLBACK_TIMEOUT = 3000;

			setTimeout(() => {
				const fallbackVideo = document.getElementById('fallback-video');

				allFrames.forEach((iframe) => {
					let iframeDoc;

					try {
						iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
					} catch (e) {
						// Cross-origin access - skip this frame
						return;
					}

					if (!iframeDoc || !iframeDoc.body) {
						return;
					}

					if (iframeDoc.body.innerHTML.trim().length === 0) {
						const fallbackUrl = iframe.getAttribute('data-fallback-url');

						if (fallbackUrl) {
							iframe.src = fallbackUrl;
							return;
						}

						if (fallbackVideo) {
							iframe.style.display = 'none';
							fallbackVideo.style.display = 'block';
						}
					}
				});
			}, FALLBACK_TIMEOUT);
		}
	};

	// Initialize the Video Fallback module
	VideoFallback.init();

}( window, document ) );
